/**
 * Initializes the accordion on the page.
 * 
 * @param {string} containerSelector - CSS selector for accordion container.
 * @param {string} wrapperSelector - CSS selector for wrapping accordion parent elements.
 * @param {string} buttonSelector - CSS selector for accordion buttons.
 * @param {string} contentSelector - CSS selector for accordion content.
 * 
 * @returns {null} Returns null if the accordion container or its elements are not found.
 */

function accordionToggleState(parentEl, contentEl, activeClass) {
  parentEl.classList.toggle(`${activeClass}`);

  if (parentEl.classList.contains(`${activeClass}`)) {
    contentEl.style.height = contentEl.scrollHeight + 'px';
  } else {
    contentEl.style.height = 0;
  }
}

function initializeAccordion(containerSeceltor, acrdWrapperSelectors, buttonSelector, contentSelector) {
  const accordionContainer = document.querySelector(`${containerSeceltor}`);

  if (!accordionContainer) {
    return null;
  }

  const accordionElements = accordionContainer.querySelectorAll(`${acrdWrapperSelectors}`);

  if (accordionElements.length === 0) {
    return null;
  }

  const ACTIVE_CLASS = 'active';

  accordionElements.forEach(accordeonElement => {
    const handlerButtonsEl = accordeonElement.querySelectorAll(buttonSelector);
    const contentEl = accordeonElement.querySelector(contentSelector);

    if (handlerButtonsEl.length === 0 || !contentEl) {
      return null;
    }

    handlerButtonsEl.forEach(buttonEl => {
      buttonEl.addEventListener('click', () => {
        accordionToggleState(accordeonElement, contentEl, ACTIVE_CLASS);
      });
    });
  });
}

export default initializeAccordion;